import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { VarIndicatorProps } from './VarIndicator';

import { VarIndicator } from './VarIndicator';

const LABELS = {
  DRAFT: 'Concept',
  REJECTED: 'Concept',
  SUBMITTED: 'Verificatie',
  ACTIVE: 'Actief',
};

const codeString =
  '<VarIndicator label={[string]: [string]} maxSteps={number} currentStep={number} onClick={() => void} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/VarIndicator',
  component: VarIndicator,
  argTypes: {},
  parameters: {
    inspectComponent: VarIndicator,
    codeString: codeString,
  },
} as Meta<VarIndicatorProps>;

const Template: StoryFn<VarIndicatorProps> = (args) => (
  <div style={{ margin: '0 0 0 6rem' }}>
    <VarIndicator {...args} />
  </div>
);

const defaultArgs: Partial<VarIndicatorProps> = {
  label: LABELS,
  maxSteps: 3,
  currentStep: 2,
  onClick: fn(),
};

export const VarIndicatorExample = Template.bind({});
VarIndicatorExample.args = {
  ...defaultArgs,
};
